import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import oops from "../../assets/oops.svg";
import SectionWrapper from "../SectionWrapper/SectionWrapper";
import {oopsPageIDs} from "../../qaIDs.json"

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(11),
    "& h2": {
      marginBottom: theme.spacing(2)
    },
    "& h3": {
      marginBottom: theme.spacing(1.5)
    },
    "& img": {
      height: 85,
      width: 85
    },
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(3),
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  textWrapper: {
    width: 410,
    marginLeft: theme.spacing(6),
    [theme.breakpoints.down("md")]: {
      marginLeft: 0,
      marginTop: theme.spacing(3),
      maxWidth: 410,
      width: "auto"
    }
  }
}));

export default function ErrorSection() {
  const classes = useStyles();

  const { t } = useTranslation();
  return (
    <SectionWrapper>
      <div className={classes.root}>
        <img src={oops} alt="" />
        <div className={classes.textWrapper}>
          <Typography variant="h2" id={oopsPageIDs.oopsH2Word}>{t("Oops")}</Typography>
          <Typography variant="h3" id={oopsPageIDs.oopsTitle}>{t("Oops_title")}</Typography>
          <Typography id={oopsPageIDs.oopsDescription}>{t("Oops_description")}</Typography>
        </div>
      </div>
    </SectionWrapper>
  );
}
